
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Cabserviceinnavimumbai() {



const cardData = {
  keyword: 'Cab Service in Navi Mumbai',
  heading: 'Skyline Cabs: Cab Service in Navi Mumbai',
  headingDescription: 'Skyline Cabs offers reliable, affordable, and professional Cab Service in Navi Mumbai for local city rides, airport transfers, corporate travel, and outstation journeys. Whether you need Navi Mumbai taxi service for daily commuting or airport cab service in Navi Mumbai, we provide punctual drivers and well-maintained AC vehicles. From taxi in Kharghar to Vashi cab service, Nerul cab service, Belapur cab service, and Panvel cab service, we cover every major location. With transparent Navi Mumbai taxi fare, easy cab booking in Navi Mumbai, and 24x7 online cab service in Navi Mumbai, Skyline Cabs ensures safe and comfortable travel across the city.',

  top: 'Top Places to Visit in Navi Mumbai with Skyline Cabs',

  topPlaces: [
    {
      title: "Central Park, Kharghar",
      description: "Central Park is one of the largest urban parks in Navi Mumbai featuring jogging tracks, gardens, fountains, and event spaces. It is a perfect spot for morning walks and family outings. Surrounded by hills, it offers scenic views and peaceful ambiance."
    },
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is known for its smooth infrastructure and sea-facing views. It connects Vashi to Belapur and is ideal for scenic drives and photography."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historic landmark offering panoramic views of the city and creek areas. It is surrounded by greenery and attracts history enthusiasts."
    },
    {
      title: "Pandavkada Waterfalls",
      description: "Pandavkada Waterfalls is a popular monsoon destination offering natural beauty and refreshing environment."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium hosts major sports events and concerts and is a well-known landmark in Navi Mumbai."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple is a peaceful spiritual destination offering serene surroundings and beautiful architecture."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall offers premium shopping, dining, and entertainment options under one roof."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a green getaway for nature lovers and bird watchers near Navi Mumbai."
    },
    {
      title: "Rock Garden, Nerul",
      description: "Rock Garden provides sea-facing walking paths and a calm environment ideal for families and couples."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is known for its lively architecture and vibrant atmosphere surrounded by cafes and restaurants."
    }
  ],

  services: [
    {
      name: "Local Cab Service in Navi Mumbai",
      description: "Skyline Cabs provides trusted cab service in Navi Mumbai including taxi Navi Mumbai for daily commuting, office travel, and city rides. Whether you need Navi Mumbai taxi service or taxi service in Navi Mumbai, we ensure transparent Navi Mumbai taxi fare and professional drivers. Our cab booking in Navi Mumbai is simple and secure with instant confirmation."
    },
    {
      name: "Area Based Taxi Service",
      description: "We provide taxi in Kharghar, Vashi cab service, Nerul cab service, Belapur cab service, and Panvel cab service for smooth local transportation. Our Navi Mumbai cab service ensures punctual pickups and comfortable travel across all major sectors."
    },
    {
      name: "Online & Advance Cab Booking",
      description: "Skyline Cabs offers online cab service in Navi Mumbai for quick and secure reservations. Customers can book cab service in Navi Mumbai anytime with real-time confirmation and transparent fare display."
    },
    {
      name: "Airport Cab Service in Navi Mumbai",
      description: "Our airport cab service in Navi Mumbai ensures smooth pickup and drop transfers to Mumbai and Navi Mumbai airports. Reliable taxi service in Navi Mumbai with professional chauffeurs and AC vehicles guarantees comfortable airport travel."
    }
  ],

  tableData: [
    ["Cab Service in Navi Mumbai", "Navi Mumbai Taxi Service"],
    ["Taxi Navi Mumbai", "Taxi Service in Navi Mumbai"],
    ["Navi Mumbai Cab Service", "Navi Mumbai Taxi Fare"],
    ["Book Cab Service in Navi Mumbai", "Online Cab Service in Navi Mumbai"],
    ["Best Cab Service in Navi Mumbai", "Cheapest Cab Service in Navi Mumbai"],
    ["Reliable Taxi Service in Navi Mumbai", "Cab Booking in Navi Mumbai"],
    ["Vashi Cab Service", "Nerul Cab Service"],
    ["Belapur Cab Service", "Kharghar Cab Service"],
    ["Panvel Cab Service", "Airport Cab Service in Navi Mumbai"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Citywide Coverage",
      WhyChoosedescription: "We cover all major areas including Vashi, Nerul, Belapur, Kharghar, and Panvel with fast response time."
    },
    {
      WhyChooseheading: "Transparent Taxi Fare",
      WhyChoosedescription: "Our Navi Mumbai taxi fare is clear and upfront without hidden charges."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Book cab service in Navi Mumbai anytime including late night and early morning rides."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription: "Verified and experienced drivers ensure safe and smooth city travel."
    },
    {
      WhyChooseheading: "Clean & AC Vehicles",
      WhyChoosedescription: "Well-maintained AC vehicles for comfortable city and airport rides."
    },
    {
      WhyChooseheading: "Easy Online Booking",
      WhyChoosedescription: "Quick and secure online cab booking in Navi Mumbai with instant confirmation."
    },
    {
      WhyChooseheading: "Affordable & Premium Options",
      WhyChoosedescription: "Choose from budget sedan to premium Innova based on your comfort needs."
    },
    {
      WhyChooseheading: "Reliable & On-Time Service",
      WhyChoosedescription: "We ensure punctual pickup and drop service across Navi Mumbai."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book a Cab Service in Navi Mumbai with Skyline Cabs?',
        answer:
            'Booking a Cab Service in Navi Mumbai is quick and easy with Skyline Cabs. Visit our website or app, enter your pickup and drop location, choose your preferred vehicle, and confirm your ride instantly.',
    },
    {
        id: 2,
        question: 'Is Skyline Cabs available 24/7 in Navi Mumbai?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Cab Service in Navi Mumbai for local travel, airport transfers, and outstation trips, including late-night and early-morning rides.',
    },
    {
        id: 3,
        question: 'What types of vehicles are available under Cab Service in Navi Mumbai?',
        answer:
            'We offer a wide fleet including Sedans, SUVs, Ertiga, Innova Crysta, and luxury vehicles — suitable for daily travel, family trips, corporate travel, and airport transfers.',
    },
    {
        id: 4,
        question: 'Is Cab Service in Navi Mumbai affordable and transparent?',
        answer:
            'Yes, Skyline Cabs follows transparent pricing. The fare shown during booking includes driver charges and applicable taxes, ensuring no hidden costs.',
    },
    {
        id: 5,
        question: 'Can I book a cab in Navi Mumbai for airport transfers?',
        answer:
            'Absolutely. Our Cab Service in Navi Mumbai includes reliable airport pickups and drops with real-time tracking and punctual service.',
    },
    {
        id: 6,
        question: 'Do you offer outstation cab services from Navi Mumbai?',
        answer:
            'Yes, we provide outstation Cab Service in Navi Mumbai to destinations like Pune, Nashik, Lonavala, Mahabaleshwar, and more at competitive rates.',
    },
    {
        id: 7,
        question: 'Are online payments available for Cab Service in Navi Mumbai?',
        answer:
            'Yes, we support secure online payments via UPI, credit/debit cards, and net banking. Instant booking confirmation is provided after successful payment.',
    },
    {
        id: 8,
        question: 'Can I pre-book my cab in Navi Mumbai?',
        answer:
            'Yes, you can schedule your Cab Service in Navi Mumbai in advance for any date and time to ensure guaranteed availability.',
    },
    {
        id: 9,
        question: 'Is Cab Service in Navi Mumbai suitable for corporate travel?',
        answer:
            'Definitely. Skyline Cabs provides professional drivers, clean vehicles, punctual service, and billing support for corporate and business travel needs.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Cab Service in Navi Mumbai?',
        answer:
            'Skyline Cabs offers reliable service, professional chauffeurs, well-maintained cars, affordable pricing, and 24x7 customer support — making us a trusted Cab Service in Navi Mumbai.',
    },
];

const someReviews = [
    {
        name: "Mr. Vivek Patil",
        rating: 5,
        review: "Used Skyline’s Cab Service in Navi Mumbai for airport transfer. The car was clean, driver was polite, and pickup was perfectly on time. Highly satisfied!"
    },
    {
        name: "Ms. Radhika Sharma",
        rating: 4,
        review: "Very dependable Cab Service in Navi Mumbai. Easy booking process, fair pricing, and comfortable ride. Will definitely book again."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/cab-service-in-navi-mumbai.jpg",
  "description": "Book Cab Service in Navi Mumbai with Skyline Cabs for local, airport and outstation travel. Affordable taxi service available in Vashi, Nerul, Belapur, Kharghar and Panvel with sedan, SUV and Innova cars driven by professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/cab-service-in-navi-mumbai"
  }
};


      


    return (
        <div>

<Helmet>
  <title>Cab Service in Navi Mumbai | Local & Airport Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Cab Service in Navi Mumbai with Skyline Cabs for reliable local, airport and outstation taxi service. Available in Vashi, Nerul, Belapur, Kharghar and Panvel at affordable fares." 
  />
  <meta 
    name="keywords" 
    content="cab service in navi mumbai, navi mumbai taxi fare, navi mumbai taxi service, taxi navi mumbai, taxi in kharghar, taxi service in navi mumbai, navi mumbai cab service, book cab service in navi mumbai, online cab service in navi mumbai, best cab service in navi mumbai, cheapest cab service in navi mumbai, reliable taxi service in navi mumbai, cab booking in navi mumbai, vashi cab service, nerul cab service, belapur cab service, kharghar cab service, panvel cab service, airport cab service in navi mumbai, outstation cab service in navi mumbai, mumbai airport cab service navi mumbai, navi mumbai airport cab service, innova cab service in navi mumbai, sedan cab service in navi mumbai, suv cab service in navi mumbai, Skyline Cabs Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
    

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/120.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinnavimumbai;